import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const cancelPickup = {
  name: "cancelPickup" as const,
  input: z.object({ teamId: zExt.objectId(), pickupId: zExt.objectId() }),
  output: z.object({ success: z.boolean(), error: z.string().optional() }),
};
